import { AppLayout } from "../shared";
import InviteCodes from "../MasterOrg/InviteCodes";

const MasterOrgInviteCodes_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <InviteCodes props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgInviteCodes_layout;
